import { render, staticRenderFns } from "./AdministrationStationDashboardManage.vue?vue&type=template&id=80f1dbb0&scoped=true"
import script from "./AdministrationStationDashboardManage.vue?vue&type=script&lang=js"
export * from "./AdministrationStationDashboardManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f1dbb0",
  null
  
)

export default component.exports